import { Fragment, useEffect, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/24/outline'
import { validateDebt } from '../debtUtilities';
import { useForm } from "react-hook-form";
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline'


export default function AddDebtRow(props) {
  const [open, setOpen] = useState(true);
  const [debt, setDebt] = useState(
    props.debt ??
    {
      id: props.id,
      invoiceid: '',
      description: '',
      invoiceDate: '',
      dueDate: '',
      capital: 0,
      reminder: '',
      payments: [

      ]
    }
  );
  const [validationResult, setValidationResult] = useState({ valid: false, messages: [] });
  const [paymentAdded, setPaymentAdded] = useState(null);
  
  const [clicked, setClicked] = useState(false);
  const [isChecked, setIsChecked] = useState(false)

  const validateRequiredFields = (includePayments = isChecked) => {
    const messages = [];
    
    if (!debt.invoiceid || debt.invoiceid.trim() === '') {
      messages.push({id: "invoiceid", message: "Fyll i fakturanummer"});
    }
    if (!debt.description || debt.description.trim() === '') {
      messages.push({id: "description", message: "Fyll i beskrivning"});
    }
    if (!debt.invoiceDate) {
      messages.push({id: "invoiceDate", message: "Välj fakturadatum"});
    }
    if (!debt.dueDate) {
      messages.push({id: "dueDate", message: "Välj förfallodatum"});
    }
    if (!debt.capital || debt.capital <= 0) {
      messages.push({id: "capital", message: "Kapitalbelopp måste vara minst 1"});
    }
    
    if (includePayments) {
      debt.payments.forEach((payment, index) => {
        if (!payment.amount || payment.amount <= 0) {
          messages.push({id: "amount_" + index, message: "Kapitalbelopp måste vara minst 1"});
        }
        if (!payment.tranctionDate) {
          messages.push({id: "invoiceDate_" + index, message: "Välj betalningsdatum"});
        }
        if (!payment.invoiceId || payment.invoiceId.trim() === '') {
          messages.push({id: "invoiceId_" + index, message: "Fyll i fakturanummer"});
        }
      });
    }
    
    return { valid: messages.length === 0, messages };
  };
  
  const attemptSubmit = () => {
    const validationResults = validateRequiredFields();
    setValidationResult(validationResults);
    if (!validationResults.valid) {
      return;
    }
    const result = validateDebt(debt);
    setValidationResult(result);
    if (result.valid) {
      afterSubmitFunction();
    }
  };

  const handleSubmit = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    attemptSubmit();
  };

  const afterSubmitFunction = () => {
    setOpen(false);
    props.notifyParent(false, debt)
  };
  
  function close(cancelled) {
    if (cancelled) {
      setOpen(false);
      props.notifyParent(true, null);
    }
  }

  
  useEffect(() => {
    if (paymentAdded == undefined) {
      return;
    }
    document.getElementById("amount_" + paymentAdded).value = "";
    document.getElementById("amount_" + paymentAdded).focus();
  }, [paymentAdded]);


    useEffect(() => {
        if (!props.debt) return;

        setDebt({
            id: props.debt.id,
            invoiceid: props.debt.invoiceid ?? '',
            description: props.debt.description ?? '',
            invoiceDate: props.debt.invoiceDate ?? '',
            dueDate: props.debt.dueDate ?? '',
            capital: props.debt.capital ?? 0,
            reminder: props.debt.reminder ?? '',
            payments: props.debt.payments ?? []
        });

        // om debt har payments så checka checkbox
        setIsChecked((props.debt.payments ?? []).length > 0);

        // städa valideringsfel
        setValidationResult({ valid: true, messages: [] });

    }, [props.debt]);

  
  function addPayment() {
    // Create a new payment object
    const newPayment = {
      amount: 0,
      tranctionDate: null,
      bookedDate: null,
      invoiceId: debt.invoiceid || '' // Default to current invoice if available
    };

    setDebt((prevDebt) => ({
      ...prevDebt,
      payments: [...prevDebt.payments, newPayment]
    }));
    setPaymentAdded(debt.payments.length ?? 0);
  };

    function removePayment(index) {
        setDebt(prevDebt => {
            const updatedPayments = prevDebt.payments.filter((_, i) => i !== index);

            if (updatedPayments.length === 0) {
                setIsChecked(false);
            }

            return {
                ...prevDebt,
                payments: updatedPayments
            };
        });

        setValidationResult(validateRequiredFields(false));
    }

  const handlePaymentChange = (index, field, value) => {
    setDebt((prevDebt) => {
      const updatedPayments = [...prevDebt.payments];
      updatedPayments[index] = {
        ...updatedPayments[index],
        [field]: value,
      };
      return { ...prevDebt, payments: updatedPayments };
    });
  };

    const handleCheckboxChange = () => {
        const next = !isChecked;
        setIsChecked(next);

        if (next) {
            if (debt.payments.length === 0) {
                addPayment();
            }
        } else {
            setDebt(prevDebt => ({
                ...prevDebt,
                payments: []
            }));
            setValidationResult(validateRequiredFields(false));
        }
    };


  const handleSubmitButtonClick = () => {
    const validationResults = validateRequiredFields();
    setValidationResult(validationResults);
  };

  const validateField = (fieldName, value) => {
    let message = null;
    
    switch(fieldName) {
      case "invoiceid":
        if (!value || value.trim() === '') {
          message = {id: "invoiceid", message: "Fyll i fakturanummer"};
        }
        break;
      case "description":
        if (!value || value.trim() === '') {
          message = {id: "description", message: "Fyll i beskrivning"};
        }
        break;
      case "invoiceDate":
        if (!value) {
          message = {id: "invoiceDate", message: "Välj fakturadatum"};
        }
        break;
      case "dueDate":
        if (!value) {
          message = {id: "dueDate", message: "Välj förfallodatum"};
        }
        break;
      case "capital":
        if (!value || value <= 0) {
          message = {id: "capital", message: "Kapitalbelopp måste vara minst 1"};
        }
        break;
      default:
        break;
    }
    
    return message;
  };

  const handleFieldBlur = (fieldName, value) => {
    const errorMessage = validateField(fieldName, value);
    
    if (errorMessage) {
      if (!validationResult.messages.some(m => m.id === errorMessage.id)) {
        setValidationResult(prev => ({
          ...prev,
          messages: [...prev.messages.filter(m => m.id !== errorMessage.id), errorMessage]
        }));
      }
    } else {
      setValidationResult(prev => ({
        ...prev,
        messages: prev.messages.filter(m => m.id !== fieldName)
      }));
    }
  };

  const handleDebtChange = (fieldName, value) => {
    setDebt({
      ...debt,
      [fieldName]: value
    });
    
    setValidationResult(prev => ({
      ...prev,
      messages: prev.messages.filter(m => m.id !== fieldName)
    }));
  };


  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => close(true)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8">

                <div>
                  <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" id="recipientform" onSubmit={handleSubmit}>
                    <div className="px-4 py-6 sm:px-12 sm:py-6">
                      <h1 className='py-6 text-2xl font-semibold'>Fakturauppgifter</h1>
                      <p className="text-sm">Lägg till en faktura till ditt registrerade ärende nedan.</p>
                      <div className="grid mt-5 w-[672px] grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                        <div className="sm:col-span-3">
                          <label htmlFor="invoiceid" className="block text-sm   leading-6 text-gray-900">
                            Fakturanummer
                          </label>
                          <div className=" mt-1">
                            <input
                              type="text"
                              name="invoiceid"
                              id="invoiceid"
                              autoComplete="invoiceid"
                              required={true}
                              value={debt.invoiceid}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("invoiceid", e.target.value)}
                              onBlur={(e) => handleFieldBlur("invoiceid", e.target.value)}
                            />
                            {validationResult.messages.filter(v => v.id === "invoiceid").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}
                          </div>
                        </div>                        <div className="sm:col-span-3">
                          <label htmlFor="capital" className="block text-sm   leading-6 text-gray-900">
                            Belopp inkl. moms
                          </label>
                          <div className="relative  mt-1 rounded-md shadow-sm">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            </div>
                            <input
                              value={debt.capital}
                              type="number"
                              name="capital"
                              id="capital"
                              required={true}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("capital", e.target.value)}
                              onBlur={(e) => handleFieldBlur("capital", e.target.value)}
                            />
                            {validationResult.messages.filter(v => v.id === "capital").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}

                          </div>
                        </div>
                        <div className="sm:col-span-2">
                          <label htmlFor="invoiceDate" className="block text-sm   leading-6 text-gray-900">
                            Fakturadatum
                          </label>
                          <div className="relative  mt-1 rounded-md shadow-sm">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            </div>
                            <input
                              value={debt.invoiceDate}
                              type="date"
                              name="invoiceDate"
                              id="invoiceDate"
                              required={true}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("invoiceDate", e.target.value)}
                              onBlur={(e) => handleFieldBlur("invoiceDate", e.target.value)}
                            />
                            {validationResult.messages.filter(v => v.id === "invoiceDate").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}
                          </div>
                        </div>
                        <div className="sm:col-span-2">
                          <label htmlFor="dueDate" className="block text-sm   leading-6 text-gray-900">
                            Förfallodatum
                          </label>
                          <div className="relative  mt-1 rounded-md shadow-sm">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            </div>
                            <input
                              value={debt.dueDate}
                              type="date"
                              name="dueDate"
                              id="dueDate"
                              required={true}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("dueDate", e.target.value)}
                              onBlur={(e) => handleFieldBlur("dueDate", e.target.value)}
                            />
                            {validationResult.messages.filter(v => v.id === "dueDate").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}
                          </div>
                        </div>
                        <div className="sm:col-span-2">
                          <label htmlFor="reminder" className="block text-sm   leading-6 text-gray-900">
                            Ev. påminnelse skickades
                          </label>
                          <div className="relative  mt-1 rounded-md shadow-sm">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            </div>
                            <input
                              value={debt.reminder}
                              type="date"
                              name="reminder"
                              id="reminder"
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("reminder", e.target.value)}
                              onBlur={(e) => handleFieldBlur("reminder", e.target.value)}
                            />
                            {validationResult.messages.filter(v => v.id === "reminder").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}
                          </div>
                        </div>
                        <div className="sm:col-span-full">
                          <label htmlFor="description" className="block text-sm   leading-6 text-gray-900">
                            Fakturan avser
                          </label>
                          <div className="relative  mt-1 rounded-md shadow-sm">
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                            </div>
                            <textarea
                              value={debt.description}
                              name="description"
                              id="description"
                              maxLength="160"
                              rows="1"
                              required={true}
                              className="resize-none block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              onChange={(e) => handleDebtChange("description", e.target.value)}
                              onBlur={(e) => handleFieldBlur("description", e.target.value)}
                            ></textarea>
                            <div className="flex items-center mt-5">
                              <input
                                id="checkboxId"
                                name="checkboxName"
                                type="checkbox"
                                className="h-5 w-5 flex-shrink-0 rounded border-gray-300 text-blue-1 focus:ring-black"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                              />
                              <label htmlFor="checkboxId" className="ml-2 flex-1 text-sm">
                                Jag har mottagit delbetalning av fakturan
                              </label>
                            </div>
                            {validationResult.messages.filter(v => v.id === "description").map((m) => {
                              return <span className='text-red-500'>{m.message}</span>
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    {isChecked ? (<div className="px-4 pb-6 sm:px-8 sm:pb-6">

                      <h2 className='py-4 text-lg font-semibold'>Betalningar</h2>
                      <div className="grid w-[672px] grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-10"></div>
                      <p className="text-sm">Lägg till eventuella delbetalningar här.</p>
                      {debt.payments.map((payment, index) => (
                        <div key={index} className="grid mt-3 w-[672px] grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-10">
                          <div className='sm:col-span-2'>
                            <label htmlFor={"invoiceId_" + index} className="block text-sm leading-6 text-gray-900">
                              Fakturanummer
                            </label>
                            <div className="relative mt-1 rounded-md shadow-sm">
                              <input
                                value={payment.invoiceId || ''}
                                          onChange={(e) => handlePaymentChange(index, 'invoiceId', e.target.value)}
                                          onBlur={() => {
                                              const results = validateRequiredFields(true);
                                              setValidationResult(results);
                                          }}

                                type="text"
                                name={"invoiceId_" + index}
                                id={"invoiceId_" + index}
                                required={true}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              />
                              {validationResult.messages.filter(v => v.id === ("invoiceId_" + index)).map((m, i) => (
                                <span key={i} className='text-red-500'>{m.message}</span>
                              ))}
                            </div>
                          </div>
                          
                          <div className='sm:col-span-2'>
                            <label htmlFor={"amount_" + index} className="block text-sm leading-6 text-gray-900">
                              Belopp
                            </label>
                            <div className="relative mt-1 rounded-md shadow-sm">
                              <input
                                value={payment.amount || ''}
                                          onChange={(e) => handlePaymentChange(index, 'amount', e.target.value)}
                                          onBlur={() => {
                                              const results = validateRequiredFields(true);
                                              setValidationResult(results);
                                          }}

                                type="number"
                                name={"amount_" + index}
                                id={"amount_" + index}
                                required={true}
                                className="block w-full rounded-md border-0 py-1.5 pl-4 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              />

                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                <span className="text-gray-500 sm:text-sm" id="price-currency">
                                  SEK
                                </span>
                              </div>
                            </div>
                            {validationResult.messages.filter(v => v.id === ("amount_" + index)).map((m, i) => (
                              <span key={i} className='text-red-500'>{m.message}</span>
                            ))}
                          </div>
                          <div className="sm:col-span-2">
                            <label htmlFor={"invoiceDate_" + index} className="block text-sm leading-6 text-gray-900">
                              Betalningsdatum
                            </label>
                            <div className="relative mt-1 rounded-md shadow-sm">
                              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                              </div>
                              <input
                                value={payment.tranctionDate || ''}
                                          onChange={(e) => handlePaymentChange(index, 'tranctionDate', e.target.value)}
                                          onBlur={() => {
                                              const results = validateRequiredFields(true);
                                              setValidationResult(results);
                                          }}

                                type="date"
                                name={"invoiceDate_" + index}
                                id={"invoiceDate_" + index}
                                required={true}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              />
                              {validationResult.messages.filter(v => v.id === ("invoiceDate_" + index)).map((m, i) => (
                                <span key={i} className='text-red-500'>{m.message}</span>
                              ))}
                            </div>
                          </div>
                          <div className="sm:col-span-2">
                            <label htmlFor={"bookedDate_" + index} className="block text-sm leading-6 text-gray-900">
                              Bokföringsdatum
                            </label>
                            <div className="relative mt-1 rounded-md shadow-sm">
                              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                              </div>
                              <input
                                value={payment.bookedDate || ''}
                                onChange={(e) => handlePaymentChange(index, 'bookedDate', e.target.value)}
                                type="date"
                                name={"bookedDate_" + index}
                                id={"bookedDate_" + index}
                                required={false}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-black sm:text-sm sm:leading-6"
                              />
                              {validationResult.messages.filter(v => v.id === ("bookedDate_" + index)).map((m, i) => (
                                <span key={i} className='text-red-500'>{m.message}</span>
                              ))}

                            </div>
                          </div>
                              <div class="sm:col-span-2">
                                  <div class="flex items-center gap-2">
                                      <button
                                          onClick={() => removePayment(index)}
                                          type="button"
                                          className="rounded-full bg-transparent border-solid border-2 border-red p-1.5 text-black shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600
                              mt-[28px] hover:bg-red/[.15]"
                                      >
                                          <MinusIcon stroke="red" className="h-5 w-5" aria-hidden="true" />
                                      </button>
                                      <span class="text-sm mt-6">Ta bort betalning</span>
                                  </div>
                              </div>
                        </div>
                      ))}
                      <button
                        onClick={addPayment}
                        type="button"
                        className="text-sm mt-4 flex items-center rounded-full border-solid border-2 border-green py-1.5 px-2 text-green shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 hover:bg-green-500"
                      >
                        <PlusIcon stroke="green" className="h-5 w-5" aria-hidden="true"></PlusIcon>
                        Lägg till delbetalning
                      </button>
                    </div>) : (null)}

                    <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
                      <button
                        type="button"
                        onClick={() => close(true)}
                        className="block rounded-md border-2 border-darkgrey px-5 py-2 text-center text-sm font-semibold text-black shadow-sm hover:bg-neutral-500 hover:bg-opacity-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                      >
                        Avbryt
                      </button>
                      <button
                        type="button"
                        className={`inline-flex items-center justify-center px-5 py-2 text-sm font-semibold text-center ${
                          validationResult.valid || validationResult.messages.length === 0 
                            ? "hover:text-blue-1 bg-blue-1 hover:bg-transparent border-2 border-blue-1 border-solid text-white"
                            : "bg-gray-300 border-2 border-gray-300 border-solid text-gray-500 cursor-not-allowed"
                        } rounded-md shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-1`}
                        onClick={attemptSubmit}
                      >
                        Lägg till
                      </button>

                    </div>
                  </form>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
